import {mapMutations, mapGetters, mapActions} from "vuex";
import Product from '@/modules/user-info/components/product/index.vue'

import {VueSlideToggle} from 'vue-slide-toggle';

export default {
    name: 'order-item',
    components: {
        Product,
        VueSlideToggle,
    },
    props: {
        item: {
            type: Object,
            default: () => {
            }
        }
    },
    data() {
        return {
            hideProduct: true,
            order: '',
            button: '',
            open: false,
            orderItem: this.item
        }
    },
    methods: {
        ...mapActions({
            getHistory: 'order/HISTORY_ORDERS'
        }),

        hideProducts() {
            this.order = this.button
            if (this.order === this.button) {
                this.hideProduct = !this.hideProduct
            }
        },
        getHide(val) {
            console.log(val);
        }
    },
    computed: {
        ...mapGetters({
            historyOrders: 'order/historyOrders'
        })
    },
    created() {
        this.getHistory()

    }
}
